import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { pages } from './pages';
import ScrollToTop from './components/ScrollToTop';
import './assets/FontAwesomeLibrary';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {pages.map((page, index) => (
          <Route key={index} path={page.path} element={page.element} />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
